import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { graphqlRequest } from '../../utils/graphqlRequest';
import './styles/IncomeForm.css';

const CREATE_EXPENSE_MUTATION = `
  mutation CreateFinanceExpense($input: CreateFinanceExpenseInput!) {
    createFinanceExpense(input: $input) {
      id
      vendorName
      amountSpent
      status
    }
  }
`;

const initialFormState = {
  expensesType: '',
  vendorName: '',
  amountSpent: '',
  paymentMode: '',
  paymentDate: '',
  category: '',
  status: '',
  remark: '',
};

const ExpensesForm = ({ open, onClose, onSaved }) => {
  const [formData, setFormData] = useState(initialFormState);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData(initialFormState);
    }
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.vendorName || !formData.amountSpent) {
      toast.error('Please fill in Vendor Name and Amount Spent');
      return;
    }

    try {
      setSaving(true);
      await graphqlRequest(CREATE_EXPENSE_MUTATION, {
        input: {
          expensesType: formData.expensesType || undefined,
          vendorName: formData.vendorName,
          amountSpent: parseFloat(formData.amountSpent),
          paymentMode: formData.paymentMode || undefined,
          paymentDate: formData.paymentDate || undefined,
          category: formData.category || undefined,
          status: formData.status || 'Pending',
          remark: formData.remark || undefined,
        },
      });

      setFormData(initialFormState);
      if (onSaved) onSaved();
      if (onClose) onClose();
    } catch (err) {
      console.error('Failed to create expense:', err);
      toast.error('Failed to save expense record. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="income-form-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="income-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="income-form-header">
          <h2>Add Expenses</h2>
          <button type="button" className="close-btn" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <form className="income-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-field full-width">
              <label>Expenses Type</label>
              <input
                name="expensesType"
                value={formData.expensesType}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>

            <div className="form-field full-width">
              <label>Vendor Name</label>
              <input
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                placeholder="Enter Project Id"
                required
              />
            </div>

            <div className="form-field">
              <label>Amount Spent</label>
              <input
                name="amountSpent"
                type="number"
                step="0.01"
                value={formData.amountSpent}
                onChange={handleChange}
                placeholder="Enter Project Id"
                required
              />
            </div>
            <div className="form-field">
              <label>Payment Mode</label>
              <input
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>

            <div className="form-field">
              <label>Payment Date</label>
              <input
                type="date"
                name="paymentDate"
                value={formData.paymentDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-field">
              <label>Add Category</label>
              <input
                name="category"
                value={formData.category}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>

            <div className="form-field">
              <label>Status</label>
              <input
                name="status"
                value={formData.status}
                onChange={handleChange}
                placeholder="Enter Project Id"
              />
            </div>
          </div>

          <div className="form-field remark-field">
            <label>Remark / Note</label>
            <textarea
              name="remark"
              rows={4}
              value={formData.remark}
              onChange={handleChange}
              placeholder="Message ......."
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpensesForm;
